import { render } from "./ActiveScreen.vue?vue&type=template&id=b35c7ce4&scoped=true"
import script from "./ActiveScreen.vue?vue&type=script&lang=js"
export * from "./ActiveScreen.vue?vue&type=script&lang=js"

import "./ActiveScreen.vue?vue&type=style&index=0&id=b35c7ce4&lang=scss&scoped=true"

import exportComponent from "/Users/peterdevos/Apps/clawmachine_topdesk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b35c7ce4"]])

export default __exports__